import React, { useState } from "react";
import {
  Button,
  Modal,
  Container,
  Row,
  Col,
  Alert,
} from "react-bootstrap";
import Form from "react-bootstrap/Form";

function UpdateProductoModal({ updateProducto, producto }) {
  // States del Modal
  const [show, setShow] = useState(false);
  const [error, setError] = useState(false);
  // clean state
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // States de los campos del form.
  const [nombre, setNombre] = useState(producto.producto);
  const [marca, setMarca] = useState(producto.marca);
  const [precio, setPrecio] = useState(producto.precio);
  const [tarjeta, setTarjeta] = useState(producto.tarjeta);
  const [stock, setStock] = useState(producto.stock);

  // Funcion encargada de poner en mayuscula campos importantes
  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  // Funcion encargada de tomar los datos del form y actualizar el producto en la DB.
  async function handleEdit() {
    const productoModificado = {
      producto: capitalizeFirstLetter(nombre),
      marca: capitalizeFirstLetter(marca),
      precio: precio,
      tarjeta: tarjeta,
      stock: parseInt(stock),
    };

    // Verificamos que todos los campos del form estan completos
    if (
      productoModificado.producto !== "" &&
      productoModificado.marca !== "" &&
      productoModificado.precio !== "" &&
      productoModificado.tarjeta !== "" &&
      !isNaN(productoModificado.stock)
    ) {
      // Aca tenemos que llamar a la funcion que va a hacer el servicio de crear al nuevo producto en el back y le pasamos los datos.
      updateProducto(producto.id, productoModificado);
      handleClose();
    } else {
      setError(true);
    }
  }

  const handleCancel = () => {
    setNombre(producto.producto);
    setMarca(producto.marca);
    setPrecio(producto.precio);
    setTarjeta(producto.tarjeta);
    setStock(producto.stock);
    setError(false);

    handleClose();
  };

  return (
    <>
      <Button className="m-1" variant="warning" size="sm" onClick={handleShow}>
        Editar
      </Button>

      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        size="lg"
        centered
      >
        <Modal.Header closeButton onClick={handleCancel}>
          <Modal.Title>Editar producto: "{producto.producto}"</Modal.Title>
        </Modal.Header>
        <Modal.Body className="show-grid">
          <Container>
            {error && (
              <Alert variant="danger">Debe completar todos los campos!</Alert>
            )}
            <Row>
              <Col xs={12} md={6}>
                <Form.Group
                  onChange={(e) => {
                    setNombre(e.target.value);
                  }}
                  className="mb-3"
                >
                  <Form.Label>Producto:</Form.Label>
                  <Form.Control
                    type="text"
                    required={true}
                    defaultValue={nombre}
                  />
                </Form.Group>
              </Col>

              <Col xs={12} md={6}>
                <Form.Group
                  onChange={(e) => {
                    setMarca(e.target.value);
                  }}
                  className="mb-3"
                >
                  <Form.Label>Marca:</Form.Label>
                  <Form.Control type="text" defaultValue={marca} />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col xs={12} md={4}>
                <Form.Group
                  onChange={(e) => {
                    setPrecio(e.target.value);
                  }}
                  className="mb-3"
                >
                  <Form.Label>Precio Efectivo:</Form.Label>
                  <Form.Control type="number" defaultValue={precio} />
                </Form.Group>
              </Col>

              <Col xs={12} md={4}>
                <Form.Group
                  onChange={(e) => {
                    setTarjeta(e.target.value);
                  }}
                  className="mb-3"
                >
                  <Form.Label>Precio Tarjeta:</Form.Label>
                  <Form.Control type="number" defaultValue={tarjeta} />
                </Form.Group>
              </Col>

              <Col xs={12} md={4}>
                <Form.Group
                  onChange={(e) => {
                    setStock(e.target.value);
                  }}
                  className="mb-3"
                >
                  <Form.Label>Stock:</Form.Label>
                  <Form.Control type="number" defaultValue={stock} />
                </Form.Group>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-danger" size="sm" onClick={handleCancel}>
            Cancelar
          </Button>
          <Button
            onClick={() => handleEdit()}
            variant="outline-success"
            size="sm"
          >
            Guardar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default UpdateProductoModal;
